import React, { Component } from "react";
import styled from "styled-components";
import NanoFlex from "../../Global/NanoFlex";
import Type from "../../Global/Typography.js";

const StyledTextarea = styled(NanoFlex)`
  .title {
    margin: 8px 0;
    color: ${(props) => props.theme.color.main.font};
  }
  textarea {
    border: 1px solid ${(props) => props.theme.color.greyPalette.grey};
    padding: 10px 16px;
    width: 100%;
    height: 100px;
    font-size: 16px;
    color: ${(props) => props.theme.color.main.font};
    font-family: ${(props) => props.theme.font};
    border-radius: 16px;
    resize: none;
    &::placeholder {
      font-family: ${(props) => props.theme.font};
      color: ${(props) => props.theme.color.greyPalette.grey};
    }
    &:focus {
      border: 1px solid ${(props) => props.theme.color.main.font};
    }
  }
`;

class Textarea extends Component {
  constructor(props) {
    super(props);

    this.inputRef = React.createRef();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.defaultValue !== prevProps.defaultValue) {
      this.inputRef.current.value = this.props.defaultValue;
    }
  }

  render() {
    return (
      <StyledTextarea className="TextAreaContainer" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
        {this.props.title && <Type.p className="title">{this.props.title}</Type.p>}
        <NanoFlex className="TextAreaWrapper">
          <textarea
            ref={this.inputRef}
            type={this.props.title}
            placeholder={this.props.placeholder}
            defaultValue={this.props.defaultValue}
            onChange={(e) => {
              if (this.props.onChangeAction) {
                this.props.onChangeAction(e.target.value);
              }
            }}></textarea>
        </NanoFlex>
      </StyledTextarea>
    );
  }
}

// Set default props
Textarea.defaultProps = {
  title: "Title",
  placeholder: "placeholder",
};

export default Textarea;
